import { IOfferCard } from '../../../types';
import { getAgentFee } from './getAgentFee';
import { getClientFee } from './getClientFee';

export function getFeePrice(offerCard: IOfferCard, isAgent: boolean) {
  return isAgent ? getAgentFee(offerCard) : getClientFee(offerCard);
}
